export function i18n() {
    document.addEventListener("alpine-i18n:ready", () => {
        window.AlpineI18n.create(locale, messages);
    })
}

let locale = document.querySelector('html').getAttribute('lang'),
    messages = {
        "da-DK": {
            favorit: "Favorit",
            remove_favorit: "Fjern favorit",
            assignment_closed : "Din opgave",
            assignment_open : "Luk opgaven",
            header_thumb_down : "Fortæl os gerne, hvorfor du pegede tommeltotten ned.",
            header_thumb_up : "Fortæl os gerne, hvorfor du pegede tommeltotten op.",
            notification_subscribe_title : "Tilmeld notifikationer",
            notification_edit_title : "Rediger notifikationer",
            notification_btn_subscribe : 'Tilmeld dig',
            notification_btn_edit : 'Rediger'
        },
        "kl-GL": {
            favorit: "Nuannarinerusat",
            remove_favorit: "Inissinik qituinnaarpunga",
            assignment_closed : "Inuusuttut pinnguaqarput",
            assignment_open : "Apera inuupput",
            header_thumb_down : "Oqarpoqersinnga, imminut tommelukkut paani kisianniitsoq.",
            header_thumb_up : "Oqarpoqersinnga, imminut tommelukkut paani sunnianniitsoq.",
            notification_subscribe_title : "Ataasinngaassat ukiuni",
            notification_edit_title : "Inissisimanngaassat ukiuni",
            notification_btn_subscribe : 'Ilumoorfik',
            notification_btn_edit : 'Allanngorpoq'
        }
    };
